<template>
    <div class="mobile-footer">
        <div v-if="!menuStore.mobileMenuFooterData.hideButtons"
             class="footer-buttons">
            <CurrencyButton v-if="!menuStore.mobileMenuFooterData.isErrorPage"
                            class="currency-button" />
            <ThemeButton v-if="menuStore.mobileMenuFooterData.isLightSwitcherEnabled"
                         @click="switchTheme" />
            <PromoButton />
        </div>
        <div class="connect">
            <BaseButton type="button"
                        role="link"
                        @click="onLoginClick">
                <translate translation-key="header.connect"
                           fallback="Connect" />
            </BaseButton>
        </div>
        <hr>
        <FooterIcons />
    </div>
</template>

<script setup lang="ts">
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import { route } from '@/js/helpers/helpers';
    import CurrencyButton from '@/js/global/menu/mobile-menu-footer/buttons/CurrencyButton.vue';
    import ThemeButton from '@/js/global/menu/mobile-menu-footer/buttons/ThemeButton.vue';
    import PromoButton from '@/js/global/menu/mobile-menu-footer/buttons/PromoButton.vue';
    import switchTheme from '@/js/helpers/switchTheme';
    import FooterIcons from '@/js/global/menu/mobile-menu-footer/FooterIcons.vue';
    import BaseButton from '@/js/components/BaseButton.vue';

    const menuStore = useMenuStore();

    const onLoginClick = () => {
        window.location.href = route('login');
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 300ms ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}

.mobile-footer {
    margin-top: 24px;

    .connect {
        padding: 0 8px;
    }
}

.footer-buttons {
    display: flex;
    padding: 6px 8px;
    gap: legacyVariables.$menu-container-gap;

    .currency-button {
        flex: 1.3;
    }
}

.dark-theme {
    .mobile-footer {
        background: legacyVariables.$dark-theme-bg;
    }
}
</style>
